import React from "react";
import { getValue } from "@utils/lodash";
import { convertCurrentDateWithTime } from "@common/date-helpers";
import FileLogSvgComponent from "@assets/svg-components/file-log";
import { concatString } from "@common/text-helpers";
import { handleDownloadOnClick } from "@common/downloadfile";
import "./email-log.scss";

function EmailLogViewPopup(props: any) {
  const {
    showUpdatePopup,
    setShowUpdatePopup,
    editInfo,
  } = props;

  const handleOpenAttachment = (item: any) => {
    const fileUrl = getValue(item, "content", "");
    const fileName = getValue(item, "filename", "");
    if (fileUrl) {
      handleDownloadOnClick(fileUrl, fileName);
    }
  };

  return (
    <>
      {/* <div
        className={`compelte-task-wrapper ${
          showUpdatePopup ? "compelte-task-wrapper--active" : ""
        }`}
      > */}

<div
      className={`compelte-task-wrapper email-add-edit-popup-wrapper ${
        showUpdatePopup ? "compelte-task-wrapper--active" : ""
      }`}
      // style={{ width: "60%" }}
    >
        <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
          <h6 className="compelte-task-wrapper__title">View Email Log</h6>
          <img
            src="/images/close-white.svg"
            className="img-fluid navigation-bar-wrapper__close-btn"
            onClick={() => {
              setShowUpdatePopup(false);
            }}
          />
        </div>

        <div className="d-flex max-height-mail-template email-template-wrapper main_popup_container">
          <div className="user-details-wrapper m-0 email-template-editable-content-holder w-100">
            <div className="email-template-editable-content">
              <div className="checkpoint-active-details-wrapper__form-wrapper pt-0">
                <div className="checkpoint-active-details-wrapper__form-content_email_template view-email-logs-popup mw-100">
                  <div className="sent-on-wrap">
                    <span>
                      {convertCurrentDateWithTime(
                        getValue(editInfo, `createdAt`, "")
                      )}
                    </span>
                  </div>

                  <div className="w-100">
                    <div className="mt-0 form-group">
                      <label className="checkpoint-active-details__label">
                        Recipients
                      </label>
                      <div className="val-holder">
                        {getValue(editInfo, `recipients`, []).map(
                          (item: any, index: number) => {
                            return <div key={index}>{item}</div>;
                          }
                        )}
                      </div>
                    </div>

                    <div className="border_bottom view_emaillogs_seperator"></div>

                    {getValue(editInfo, `ccrecipients`, []) && 
                     getValue(editInfo, `ccrecipients`, []).length > 0 && (
                      <>
                        <div className="mt-0 form-group">
                          <label className="checkpoint-active-details__label">
                            CC
                          </label>
                          <div className="val-holder">
                            {getValue(editInfo, `ccrecipients`, []).map(
                              (item: any, index: number) => {
                                return <div key={index}>{item}</div>;
                              }
                            )}
                          </div>
                        </div>

                        <div className="border_bottom view_emaillogs_seperator"></div>
                      </>
                    )}

                    <div className="user-details-wrapper__form-group form-group">
                      <label className="checkpoint-active-details__label">
                        Subject
                      </label>
                      <div className="val-holder">
                        {getValue(editInfo, `subject`, "")}
                      </div>
                    </div>
                  </div>

                  {Array.isArray(getValue(editInfo, `attachments`, null)) &&
                    getValue(editInfo, `attachments`, []).length > 0 && (
                      <>
                        <div className="border_bottom view_emaillogs_seperator"></div>
                        <div className="user-details-wrapper__form-group form-group">
                          <label className="checkpoint-active-details__label">
                            Attachments
                          </label>
                          <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                            {getValue(editInfo, `attachments`, []).map(
                              (item: any, index: number) => {
                                return (
                                  <div
                                    className="p-2 border border-radius__5 d-flex align-items-center cursor-pointer"
                                    key={index}
                                    onClick={() => handleOpenAttachment(item)}
                                  >
                                    <FileLogSvgComponent />
                                    <p className="small_text__16 ms-2 mb-0">
                                      {concatString(
                                        getValue(item, `filename`, "Attachment"),
                                        30
                                      )}
                                    </p>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </>
                    )}

                  <div className="border_bottom view_emaillogs_seperator"></div>

                  <div className="user-details-wrapper__form-group form-group">
                    <div
                      className="val-holder"
                      dangerouslySetInnerHTML={{
                        __html: getValue(editInfo, `html`, ""),
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="fixed_moda_footer_wrapper">
            <div style={{ marginRight: "20px" }}>
                <button
                    className="ascent-button ascent-button--header-buttons ascent-button--primary "
                    onClick={() => setShowUpdatePopup(false)}
                >
                    Close
                </button>
            </div>
        </div>
      </div>
    </>
  );
}

export default EmailLogViewPopup; 